import { DeviceType } from '../model/types';

export const APPMETRICA_REDIRECT_URLS: Record<DeviceType, string> = {
  [DeviceType.Ios]: 'https://redirect.appmetrica.yandex.com/serve/461983867696375575',
  [DeviceType.Android]: 'https://redirect.appmetrica.yandex.com/serve/894329423652792694',
  [DeviceType.AppGallery]: 'https://redirect.appmetrica.yandex.com/serve/29640983511635245',
};

export const DEFAULT_APP_DOWNLOAD_DEVICE_TYPE = DeviceType.Android;

export const FOOTER_APP_DOWNLOAD_BANNER_NAME = 'footerbanner';
